export const DRYER_FUEL_TYPE = 'Dryer Fuel Type';
export const LAUNDRY_ACCESSORIES_DRAWER = 'Laundry Accessories';
export const WASHER_TYPE = 'Agitator/Impeller Type';
export const KITCHEN_FUEL_TYPE = 'Fuel Type';
export const APPLIANCE_TYPE = 'Appliance Type';
export const LAUNDRY_ACCESSORY = 'Laundry Accessory';
export const WASHER = 'Washer';
export const DRYER = 'Dryer';
export const ACCESSORIES = 'Accessories';
export const NONE_VALUE = 'None';